// src/components/molecules/charts/base-calls-summary-chart/base-calls-summary-chart.tsx

import React from 'react';
import { Bar } from 'react-chartjs-2';
import type { ChartData } from 'chart.js';
import type { BaseCallsSummaryChartProps } from 'src/types/call-summaries';
import { Text } from 'src/modules/shared/components/atoms/text';
import { totalDatalabelPlugin } from '../utils';
import '../chartjs-registry';

const BaseCallsSummaryChart: React.FC<BaseCallsSummaryChartProps> = ({
  labels,
  effectiveCalls,
  missedCalls,
  voicemailCalls,
  chartTitle,
}) => {
  const data: ChartData<'bar'> = {
    labels,
    // TODO: check when implementing i18n
    datasets: [
      {
        label: 'Llamadas Efectivas',
        data: effectiveCalls,
        backgroundColor: '#033663',
      },
      {
        label: 'Llamadas Perdidas',
        data: missedCalls,
        backgroundColor: '#EECA86',
      },
      {
        label: 'Buzón de Voz',
        data: voicemailCalls,
        backgroundColor: '#E9AB11',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: totalDatalabelPlugin,
    },
    scales: {
      y: {
        stacked: true,
      },
      x: {
        stacked: true,
      },
    },
  };

  return (
    <section className="min-w-0 overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-sm">
      <div className="border-b border-neutral-100 px-5 py-4">
        <Text as="h3" size="h6" weight="semibold" className="text-neutral-900">
          {chartTitle}
        </Text>
      </div>
      <div className="h-[320px] px-4 py-4">
        <Bar options={options} data={data} />
      </div>
    </section>
  );
};

export default BaseCallsSummaryChart;
